import React from 'react';
import { Checkbox, Modal, Button } from 'antd';
import { FormProvider, Controller } from 'react-hook-form';
import useSIBDomainForm, { commonProps } from './useSIBDomainForm';
import { Row, Input } from 'components/ui';
import InputLabel from 'components/blocks/BugFeatureReportForm/InputLabel';
import { useAddSIBDomain, useUpdateSIBDomain } from 'mutation/admin';

export default function SIBDomainForm({ onHideForm, domainInfo }) {
  const isUpdate = !!domainInfo;
  const form = useSIBDomainForm({ domainInfo });

  const onSubmitComplete = () => {
    form.reset();
    onHideForm();
  };

  const {
    isLoading: isAddingSIBDomain,
    mutate: addSIBDomain,
  } = useAddSIBDomain({
    onSuccess: onSubmitComplete,
  });

  const {
    isLoading: isUpdatingSIBDomain,
    mutate: updateSIBDomain,
  } = useUpdateSIBDomain({
    onSuccess: onSubmitComplete,
  });

  const isLoading = isAddingSIBDomain || isUpdatingSIBDomain;

  const onConfirmSubmit = values => {
    Modal.confirm({
      title: 'Confirmation',
      content: `Are you sure you want to continue?`,
      okText: 'Yes',
      okType: 'primary',
      onOk: () => {
        const { id, ...payload } = values;

        if (isUpdate) updateSIBDomain({ id, data: payload });
        else addSIBDomain(payload);
      },
      cancelText: 'No',
    });
  };

  return (
    <Modal
      footer={[
        <Button
          disabled={isLoading}
          key="submit"
          loading={isLoading}
          type="primary"
          onClick={form.handleSubmit(onConfirmSubmit)}
        >
          {isUpdate ? 'Update' : 'Add'}
        </Button>,
      ]}
      title={isUpdate ? 'Update Domain' : 'Add Domain'}
      visible
      onCancel={onHideForm}
      onOk={form.handleSubmit(onConfirmSubmit)}
    >
      <FormProvider {...form}>
        <Row>
          <Controller
            control={form.control}
            name="name"
            render={({ field, fieldState }) => {
              return (
                <InputLabel label="Domain Name">
                  <Input type="text" {...commonProps({ field, fieldState })} />
                </InputLabel>
              );
            }}
          />
        </Row>

        <Row>
          <Controller
            control={form.control}
            name="ip"
            render={({ field, fieldState }) => {
              return (
                <InputLabel label="Dedicated IP">
                  <Input type="text" {...commonProps({ field, fieldState })} />
                </InputLabel>
              );
            }}
          />
        </Row>

        <Row>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Controller
              control={form.control}
              name="isActive"
              render={({ field, fieldState }) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 20,
                    }}
                  >
                    <InputLabel label="Is Active" />
                    <Checkbox
                      {...commonProps({ field, fieldState })}
                      checked={field.value}
                      disabled={isLoading}
                      style={{ marginTop: -25, paddingLeft: 5 }}
                    />
                  </div>
                );
              }}
            />
          </div>
        </Row>
      </FormProvider>
    </Modal>
  );
}
